import revive_payload_client_4sVQNw7RlN from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/usr/src/app/packages/all-inclusive-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/usr/src/app/packages/all-inclusive-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_iGLjBbor9q from "/usr/src/app/packages/all-inclusive-app/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import plugin_client_Fdvg3o8568 from "/usr/src/app/packages/all-inclusive-app/node_modules/@nuxtjs/web-vitals/dist/runtime/plugin.client.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/usr/src/app/packages/all-inclusive-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/usr/src/app/packages/all-inclusive-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_AUP22rrBAc from "/usr/src/app/packages/all-inclusive-app/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import apollo_client_VTaW5dp4nd from "/usr/src/app/packages/all-inclusive-app/plugins/apollo-client.ts";
import app_plugins_cX3gunOJC6 from "/usr/src/app/packages/all-inclusive-app/plugins/app-plugins.ts";
import contentful_preview_6VInQ9hA2d from "/usr/src/app/packages/all-inclusive-app/plugins/contentful-preview.ts";
import cspFieldsHandler_y5Z6Vv3sOQ from "/usr/src/app/packages/all-inclusive-app/plugins/cspFieldsHandler.ts";
import error_handler_kEP5FliEXj from "/usr/src/app/packages/all-inclusive-app/plugins/error-handler.ts";
import error_ldt3PQauZ0 from "/usr/src/app/packages/all-inclusive-app/plugins/error.ts";
import headers_to_app_TxoxhYhXEA from "/usr/src/app/packages/all-inclusive-app/plugins/headers-to-app.ts";
import weglot_hotfix_UiTfI4zR5d from "/usr/src/app/packages/all-inclusive-app/plugins/weglot-hotfix.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_iGLjBbor9q,
  plugin_client_Fdvg3o8568,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_AUP22rrBAc,
  apollo_client_VTaW5dp4nd,
  app_plugins_cX3gunOJC6,
  contentful_preview_6VInQ9hA2d,
  cspFieldsHandler_y5Z6Vv3sOQ,
  error_handler_kEP5FliEXj,
  error_ldt3PQauZ0,
  headers_to_app_TxoxhYhXEA,
  weglot_hotfix_UiTfI4zR5d
]